import React from 'react';
import { Outlet } from 'react-router-dom';
import { AnnouncementBar } from './AnnouncementBar';
import { NavBar } from './NavBar';
import { Footer } from './Footer';
export function Layout() {
  return <div className="w-full min-h-screen bg-white font-sans flex flex-col" data-id="element-275">
      <AnnouncementBar data-id="element-276" />
      <NavBar data-id="element-277" />
      <main className="flex-1" data-id="element-278">
        <Outlet data-id="element-279" />
      </main>
      <Footer data-id="element-280" />
    </div>;
}